export default __webpack_public_path__ + "static/media/network-type_phone.52b5a54a.png";